/**
 * API Configuration
 *
 * `API_URL` must include any path prefix (e.g. `http://host/api/v1`).
 * Endpoints in code are appended verbatim.
 */

export const API_URL = import.meta.env.VITE_API_URL || '';
